<template>
  <div class="">
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="kreditgenie-text-green hover:kreditgenie-text-green-hover" :href="route('settings')">Einstellungen</inertia-link>
      <span class="kreditgenie-text-green font-medium">/</span>
      {{ form.key }}
    </h1>
    <trashed-message v-if="setting.deleted_at" class="mb-6" @restore="restore">
      Diese Einstellung wurde gelöscht.
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <select-input v-model="form.key" :error="form.errors.key" class="pr-6 pb-8 w-full lg:w-1/2" label="Schlüssel">
            <option v-for="(settingOption, index) in settings" :key="index" :value="settingOption.key">{{ settingOption.key }}</option>
          </select-input>
          <text-input v-model="form.value" :error="form.errors.value" class="pr-6 pb-8 w-full lg:w-1/2" label="Value" />
          <text-input v-model="form.text" :error="form.errors.text" class="pr-6 pb-8 w-full lg:w-1/2" label="Text" />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!setting.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button"
                  @click="destroy"
          >
            Löschen
          </button>
          <button v-if="setting.deleted_at" class="text-green-600 hover:underline" tabindex="-1" type="button"
                  @click="restore"
          >
            Wiederherstellen
          </button>
          <loading-button :loading="form.processing" class="btn-green ml-auto" type="submit">
            Aktualisieren
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'
import TrashedMessage from '../../Shared/TrashedMessage'

export default {
  metaInfo() {
    return {
      title: `${this.form.key}`,
    }
  },
  components: {
    TrashedMessage,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    setting: Object,
    settings: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        key: this.setting.key,
        value: this.setting.value,
        text: this.setting.text,
      }),
    }
  },
  methods: {
    update() {
      this.form.post(this.route('settings.update', this.setting.id), {
      })
    },
    destroy() {
      if (confirm('Möchten Sie diese Einstellung wirklich löschen?')) {
        this.$inertia.delete(this.route('settings.destroy', this.setting.id))
      }
    },
    restore() {
      if (confirm('Möchten Sie diese Einstellung wirklich wiederherstellen?')) {
        this.$inertia.put(this.route('settings.restore', this.setting.id))
      }
    },
  },
}
</script>
